import { Component, Suspense } from 'react'
import { BrowserRouter as Router, Route, Switch, Redirect } from 'react-router-dom'
import './scss/style.scss'
//import Login from './views/pages/login/newLogin.jsx'
//import Register from './views/pages/Register/Register.jsx'
import { getJWTfromCookie } from './utils/handleCookie.js'
//import DefaultLayout from './layout/DefaultLayout'
import { QueryClient, QueryClientProvider } from 'react-query'
import './index.css'
import 'antd/dist/antd.less'
import { Toaster } from 'react-hot-toast'

import { lazy } from 'react'
import Loader from './components/shared/Loader'
const Login = lazy(() => import('./views/pages/login/newLogin.jsx'))
const VerificationOtp = lazy(() => import('./views/dashboard/VerificationsOtp'))
const Register = lazy(() => import('./views/pages/Register/Register.jsx'))
const DefaultLayout = lazy(() => import('./layout/DefaultLayout'))


// Pages
const ProtectedRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => (getJWTfromCookie() ? <Component {...props} /> : <Redirect to={{ pathname: '/login' }} />)} />
const PublicRoute = ({ component: Component, ...rest }) => <Route {...rest} render={(props) => (getJWTfromCookie() ? <Redirect to={{ pathname: '/home' }} /> : <Component {...props} />)} />
const queryClient = new QueryClient()
import { registerLicense} from '@syncfusion/ej2-base';
import Homepage from './views/dashboard/Homepage'
import PrivacyPolicy from './views/dashboard/privacy'
import Contactus from './views/dashboard/Contactus'


registerLicense(
  'Ngo9BigBOggjHTQxAR8/V1NNaF5cXmBCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXtedHRXRWBcUUB3V0FWYUA='
);

window.NavigationDetails = {}
window.DiagnosList = []
window.PatientData = []
window.ActiveSelection = true
class App extends Component {

  render() {
    return (
      <QueryClientProvider client={queryClient}>
        <Router>
          <Toaster />
          <Suspense fallback={<Loader />}>
            <Switch>
              <PublicRoute exact path="/" name="Homepage" component={() => <Login />} />
              <PublicRoute exact path="/contact-us" name="contact-us" component={() => <Contactus />} />
              <PublicRoute exact path="/login" name="Login Page" component={() => <Login />} />
              <PublicRoute exact path="/privacy-policy" name="Login Page" component={() => <PrivacyPolicy />} />
              <ProtectedRoute path="/home" component={() => <DefaultLayout />} />
              <PublicRoute exact path="/login" name="Login Page" component={() => <Login />} />
              <ProtectedRoute exact path="/verification" name="Otp Verification" component={() => <VerificationOtp />} />
              <ProtectedRoute exact path="/register" name="Register page" component={() => <Register />} />
              <ProtectedRoute path="/dashboard" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/datawarehouse" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/details" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/questions" component={() => <DefaultLayout />} />
              <ProtectedRoute path="/childTable" component={() => <DefaultLayout />} />
            </Switch>
          </Suspense>

        </Router>
      </QueryClientProvider>
    )
  }
}

export default App
